import { CreateStory, CreateStoryRequest } from '../../store/slices/upload';
import { msSinceArrival, msSinceAttempt } from '../analytics/telemetry';
import { useAppDispatch, useTypedSelector } from '../../store/store';
import { Dispatch, SetStateAction } from 'react';
import { incrementStoriesCount } from '../../store/slices/stories';
import { getVideoPosterWithCloudinary } from '../../pages/VideoToolPage/utils';
import { updateUserRequest } from '../../store/slices/me';
// import { useUploadFileToStorage } from './useUploadFileToStorage';
// import { posterUrl, urlToFile } from '../utilities';
import { useTrackEvent } from '../../common/hooks/useTrackEvent';
import { EventNames } from '../../common/constants/constants';
import { useIsLoggedWithMagicLinkValue } from './useIsLoggedWithMagicLinkValue';
import { getSlugScopedItem } from '../../common/utils/slugStorage';
import { useRouter } from 'next/router';
import { clear as clearPendingUpload } from '../upload/pendingUploadStore';

export const usePostStory = (setStoryId: Dispatch<SetStateAction<string>>) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { photoUrl: userPhotoUrl, email, accountId: useraccountId } = useTypedSelector((state) => state.me);
  const { trackEvent } = useTrackEvent();

  const [isLoggedWithMagicLink, updateLoggedWithMagicLinkValue] = useIsLoggedWithMagicLinkValue();

  // const { uploadFileToStorage } = useUploadFileToStorage();

  // const getStoryThumbnail = async (storyRequest: CreateStoryRequest) => {
  // Need to re-upload thumbnail image to get the ability to get it from local path using Cloudinary
  // const reuploadImage = async () => {
  //   try {
  //     await fetch(posterUrl(storyRequest.url));
  //     const thumbnailFile = await urlToFile(posterUrl(storyRequest.url), `story_thumbnail.jpg`, 'image/jpeg');

  //     const data = await uploadFileToStorage(thumbnailFile);
  //     if (!data || !data.downloadUrl) return null;

  //     return data.downloadUrl;
  //   } catch (error) {
  //     return null;
  //   }
  // };

  //   const thumbnail =  storyRequest.thumbnailUrl;

  //   return googleStorageImageUrlToCloudinaryUrl(thumbnail);
  // };

  const postStory = async (storyRequest: CreateStoryRequest) => {
    // const thumbnailUrl = await getStoryThumbnail(storyRequest);
    const currentSlug = router.query.slug as string;
    const campaignId = getSlugScopedItem('campaignId', currentSlug);
    const associationId = getSlugScopedItem('associationId', currentSlug) || null;

    return dispatch(CreateStory({ ...storyRequest, campaignId, attributes: { associationId } })).then((data) => {
      if (!data.payload) {
        // something goes wrong
        console.error((data as any).error);
        return;
      }

      // Bytes are committed AND the server has the story — the resume record
      // is no longer needed. Clear so we don't pester the user on next visit.
      clearPendingUpload();

      //@ts-ignore
      setStoryId(data.payload.id);
      dispatch(incrementStoriesCount());
      if (!userPhotoUrl) {
        // @ts-ignore
        const { url, userId } = data.payload;
        const poster = getVideoPosterWithCloudinary(url, trackEvent);
        dispatch(
          updateUserRequest({
            userId: userId || '',
            photoUrl: poster || '',
            accountId: useraccountId,
            email: email,
          }),
        );
      }
      if (isLoggedWithMagicLink) {
        updateLoggedWithMagicLinkValue();
      }

      trackEvent({
        action: EventNames.Video_Created,
        ms_since_attempt: msSinceAttempt(),
        ms_since_arrival: msSinceArrival(),
      });
      return data;
    });
  };

  return postStory;
};
